export enum MethodManagerModals {
  EditMethod,
  AddMethod,
  EditManualTask,
}
